// @flow
import React, { useCallback, useMemo } from 'react';
import { useFormikContext } from 'formik';
import { DataFetcherContainer } from '@presentational/DataFetcherContainer';
import { useGetStreamingProjectsMetadataQuery } from '@streaming-projects/service-definitions/streamingProjectsApi';
import { getRateCardVersionFromFormikValues } from '@src/common-utils/utils';

import { EstimateCommittedCapacityMetadataContext } from './EstimateCommittedCapacityMetadataContext';

export const EstimateCommittedCapacityMetadataContextProvider = ({ children }) => {
  const { initialValues } = useFormikContext();

  // Note: We are taking initialValues here, as, in some cases, the RC is cleared  and we don't want this Provider to throw
  // When is RC cleared? Ex: When Commit Type is changed.
  const rateCard = getRateCardVersionFromFormikValues(initialValues);

  if (!rateCard) {
    throw new Error('An estimate must have a valid rate card!');
  }

  const tagsToQuery = [
    `RATE_CARD=${rateCard}`,
    'COMMITTED_CKU_CAPACITY_CONFIGS',
    'COMMITTED_CFU_CAPACITY_CONFIGS',
    'COMMITTED_CONNECT_CAPACITY_CONFIGS',
    'COMMITTED_TABLEFLOW_CAPACITY_CONFIGS',
  ];

  const query = tagsToQuery.join(',');

  const dataFetchingArgs = useMemo(() => [{ query }, { skip: !rateCard }], [query, rateCard]);
  const dataFetchingFunction = useCallback(useGetStreamingProjectsMetadataQuery, []);

  return (
    <DataFetcherContainer
      dataFetchingArgs={dataFetchingArgs}
      dataFetchingFunction={dataFetchingFunction}
    >
      {(data) => (
        <EstimateCommittedCapacityMetadataContext.Provider value={data}>
          {children}
        </EstimateCommittedCapacityMetadataContext.Provider>
      )}
    </DataFetcherContainer>
  );
};
